var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 124,
    viewBox: "0 0 119 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.36 46.1038C106.472 46.1038 108.184 44.3899 108.184 42.2758C108.184 40.1616 106.472 38.4478 104.36 38.4478C102.247 38.4478 100.535 40.1616 100.535 42.2758C100.535 44.3899 102.247 46.1038 104.36 46.1038Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76619 66.8049C4.15583 66.8049 5.28236 65.6774 5.28236 64.2865C5.28236 62.8956 4.15583 61.7681 2.76619 61.7681C1.37654 61.7681 0.250011 62.8956 0.250011 64.2865C0.250011 65.6774 1.37654 66.8049 2.76619 66.8049Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3325 112.081C15.7222 112.081 16.8487 110.954 16.8487 109.563C16.8487 108.172 15.7222 107.044 14.3325 107.044C12.9429 107.044 11.8164 108.172 11.8164 109.563C11.8164 110.954 12.9429 112.081 14.3325 112.081Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7822 112.081L63.0912 101.017V55.6558L27.7822 66.6345V112.081Z",
    fill: "#B7BFCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M98.4003 112.081L63.0913 101.017V55.6558L98.4003 66.6345V112.081Z",
    fill: "#6D7C9A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7822 112.081L63.0912 101.017V55.6558L27.7822 66.6345V112.081Z",
    fill: "url(#paint0_linear_17024_47333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4002 112.081L63.0912 101.017V55.6558L98.4002 66.6345V112.081Z",
    fill: "url(#paint1_linear_17024_47333)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.0912 123.231L27.7822 112.167V66.8052L63.0912 77.869V123.231Z",
    fill: "#EDF1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0913 123.231L98.4003 112.167V66.8052L63.0913 77.869V123.231Z",
    fill: "#DAE1ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M55.0912 115.231L27.7822 112.167V66.8052L63.0912 77.869L55.0912 115.231Z",
    fill: "url(#paint2_linear_17024_47333)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.0913 107.231L98.4003 112.167V66.8052L63.0913 77.869L71.0913 107.231Z",
    fill: "url(#paint3_linear_17024_47333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0913 55.656L46.4902 43.2305L10.5913 55.3156L27.7823 66.6347L63.0913 55.656Z",
    fill: "#DAE1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0913 55.656L79.6924 43.2305L115.591 55.3156L98.4003 66.6347L63.0913 55.656Z",
    fill: "#DAE1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7823 66.8052L63.0913 77.869L45.479 89.1031L10.5913 77.5286L27.7823 66.8052Z",
    fill: "#EFF4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4003 66.8052L63.0913 77.869L80.7037 89.1031L115.591 77.5286L98.4003 66.8052Z",
    fill: "#EDF1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9428 12.107C77.8894 25.5315 79.3638 28.5143 79.8477 41.7422C79.6616 44.7617 79.5462 48.045 78.1227 50.6889C76.2216 54.7334 71.5715 57.5343 67.1782 57.5797C62.6523 57.6606 58.2152 54.8895 56.218 50.6163C54.8129 48.023 54.8576 44.4758 56.785 42.1212C58.8803 39.8631 62.5665 39.3 65.2182 40.711C68.1351 42.0509 69.8761 44.8371 70.521 47.7755C71.1659 50.7138 70.8825 53.9007 70.0954 56.7984C68.4491 63.8459 67.0856 64.1868 63.0483 76.1186",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9632 5.00156C78.9517 6.97553 77.1147 8.18423 74.7852 7.55393C72.3324 7.13582 70.5965 6.7049 70.4847 4.9431C70.541 3.13631 72.5123 2.42916 74.8196 1.63201C77.5862 0.532689 78.8067 3.07258 78.9632 5.00156Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.114 11.0379C64.357 12.3176 66.9777 12.6907 68.2548 10.7361C69.6551 8.5693 70.8538 6.99406 69.566 5.54725C68.323 4.26761 67.1132 5.12913 64.3467 6.22845C62.1289 7.35996 61.6581 9.63611 63.114 11.0379Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8496 2.87235C69.9809 2.39019 71.3361 2.74392 71.9407 3.65701C72.1983 3.94637 72.5006 4.40292 72.5902 4.73728C73.5531 6.98781 73.2503 9.21896 71.951 9.74612C70.5285 10.4855 68.5687 9.21863 67.8186 7.09029C67.6395 6.42157 67.5499 6.08721 67.4156 5.58567C67.2702 4.37041 67.7183 3.35452 68.8496 2.87235C68.8496 2.87235 69.0176 2.82735 68.8496 2.87235Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8486 39.1007H14.6585V36.9106H12.7814V39.1007H10.5913V41.0404H12.7814V43.2305H14.6585V41.0404H16.8486V39.1007Z",
    fill: "url(#paint4_linear_17024_47333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6596 94.0475H19.4696V91.8574H17.5924V94.0475H15.4024V95.9872H17.5924V98.1773H19.4696V95.9872H21.6596V94.0475Z",
    fill: "url(#paint5_linear_17024_47333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.397 94.1718L114.718 92.819L116.071 90.1394L113.774 88.9798L112.421 91.6594L109.741 90.3065L108.543 92.6798L111.223 94.0327L109.87 96.7122L112.167 97.8718L113.519 95.1923L116.199 96.5452L117.397 94.1718Z",
    fill: "url(#paint6_linear_17024_47333)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17024_47333",
    x1: 51.945,
    y1: 58.9411,
    x2: 47.1289,
    y2: 78.9909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17024_47333",
    x1: 51.945,
    y1: 58.9411,
    x2: 47.1289,
    y2: 78.9909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17024_47333",
    x1: 35.6983,
    y1: 97.8505,
    x2: 44.1809,
    y2: 73.8923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17024_47333",
    x1: 82.1471,
    y1: 104.395,
    x2: 82.8142,
    y2: 73.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17024_47333",
    x1: 13.7204,
    y1: 37.1302,
    x2: 13.7204,
    y2: 40.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17024_47333",
    x1: 18.5315,
    y1: 92.077,
    x2: 18.5315,
    y2: 95.6242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17024_47333",
    x1: 114.787,
    y1: 89.8285,
    x2: 112.596,
    y2: 94.1687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/NoTransaction.8c2cd4db.svg";
export { ForwardRef as ReactComponent };